module.exports = __webpack_public_path__ + "page-heading.8fb7be94ce7b6a196222.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/page-heading.jpg
// module id = ../../../../../src/assets/images/page-heading.jpg
// module chunks = styles